import React from 'react';
import Spacer from 'src/components/Layout/Spacer';
import styled from 'styled-components';

interface HeaderProps {
  title: string;
}
const TitleContainer = styled.div`
  font-size: ${({ theme }) => theme.fontSize.l};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const Header: React.FC<HeaderProps> = (props) => {
  if (!props.title) {
    return null;
  }
  return (
    <div>
      <Spacer height="10px" />
      <TitleContainer>{props.title}</TitleContainer>
      <hr />
      <Spacer height="10px" />
    </div>
  );
};
